import { CoreDataSecurityMonitorsByApplicationName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityMonitorsByApplicationSlice } from './get';
import { PatchDataSecurityMonitorByIdRequest } from '@api/data-security';

export const updateCoreDataSecurityMonitorsByApplicationSyncSlice = createUpdateSyncSlice({
	name: CoreDataSecurityMonitorsByApplicationName,
	state: getCoreDataSecurityMonitorsByApplicationSlice.asyncState,
	transform: (action: PatchDataSecurityMonitorByIdRequest, state = []) => {
		const index = state.findIndex((monitor) => monitor.id === action.id);

		if (index === -1) {
			return state;
		}

		const target = state[ index ];

		if (!target) {
			return state;
		}

		return [
			...state.slice(0, index),
			{
				...target,
				...action
			},
			...state.slice(index + 1)
		];
	}
});
